// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Ob-z","title":"Pb-z","cta":"Qb-z","disabled":"Rb-z"};